import { GET, POST } from "./api.js";

export const requestPlan = {
    save: (data) => POST(`/requestplan/save`, data),
    // homePlans: () => GET(`/plans/homeplans`)
}